module.exports = __webpack_public_path__ + "static/img/product_images_38_h5_zh.bceb8e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_images_38_h5_zh.png
// module id = Ry7u
// module chunks = 34